// Module
var code = "<div class=\"spond-footer-component\"> <div class=\"footer\"> <div class=\"store-logos\"> <a href=\"//ios.spond.com\"> <img [src]=\"appStoreIconUrl\"/> </a> <a href=\"//android.spond.com\"> <img [src]=\"playStoreIconUrl\"/> </a> </div> <p [innerHTML]=\"note\"> </p> </div> </div> ";
// Exports
export default code;